import { useNavigate } from 'react-router-dom';
import './AdminLayout.css'; // we'll create this next

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await fetch('https://infuse-backend.onrender.com/api/auth/logout', {
      method: 'POST',
      credentials: 'include',
    });
    navigate('/admin/login');
  };

  return (
    <div className="admin-layout">
      <nav className="admin-nav">
        <span className="admin-title">Admin Panel</span>
        <div>
          <button onClick={() => navigate('/admin/dashboard')}>Dashboard</button>
          <button onClick={() => navigate('/admin/add')}>Add Product</button>
          <button onClick={() => navigate('/admin/add/catalog')}>Add Catalog</button>
          <button onClick={handleLogout}>Logout</button>
        </div>
      </nav>
      <div className="admin-content">{children}</div>
    </div>
  );
};

export default AdminLayout;